<template>
  <div class="banks-accordion accordion" role="tablist">
    <b-card
      no-body
      class="bank-accordion-card shadow-none"
      v-for="(bank, i) in bankList.slice(0, listLimit)"
      :key="i"
    >
      <b-card-header header-tag="header" class="p-2" role="tab">
        <div
          class="d-flex justify-content-between"
          :class="{ 'bank-accordion-card-header pb-1': collapseStates[i] }"
          @click="setSelectStates(i)"
        >
          <div class="checkbox-container mr-2">
            <b-form-radio
              size="lg"
              v-model="selectedBank"
              name="cover-letter-radios"
              :value="i"
            />
          </div>
          <div
            :ref="'accordion-' + i"
            v-b-toggle="'accordion-' + i"
            class="d-flex flex-column collapse-header"
          >
            <p class="m-0 bank-name">{{ bank.buyer_bank_name }}</p>
            <div class="drip-body-small font-weight-400 mb-1">
              {{ bank.swift_code }} | {{ bank.contact_name }} |
              {{ bank.contact_phone }}
            </div>
          </div>

          <div class="d-flex">
            <p class="mr-3 m-0 action-icon">
              <b-icon-trash
                font-scale="1.5"
                class="trash"
                @click="openDialog(i)"
              />
            </p>
            <b-icon-chevron-down
              font-scale="1.5"
              class="chevron"
              v-if="!collapseStates[i]"
              v-b-toggle="'accordion-' + i"
            />
            <b-icon-chevron-down
              font-scale="1.5"
              class="chevron active"
              v-else
              v-b-toggle="'accordion-' + i"
            />
          </div>
        </div>
      </b-card-header>
      <b-collapse
        v-model="collapseStates[i]"
        :id="'accordion-' + i"
        visible
        accordion="my-accordion"
        role="tabpanel"
      >
        <b-card-body class="accordion-body pt-0">
          <div class="d-flex">
            <div class="drip-label w-200 mb-1">
              {{ $t('coverLetter.fields.bankAddress') }}
            </div>
            <div class="drip-label font-weight-400">
              {{ bank.buyer_bank_address }}
            </div>
          </div>
          <div class="d-flex">
            <div class="drip-label w-200 mb-1">
              {{ $t('coverLetter.fields.pinCode') }}
            </div>
            <div class="drip-label font-weight-400">{{ bank.post_code }}</div>
          </div>
        </b-card-body>
      </b-collapse>
      <div v-if="i !== bankList.length - 1" class="divider"></div>
      <div
        v-if="
          bankList.length > 3 &&
          i === bankList.slice(0, listLimit).length - 1 &&
          listLimit !== bankList.length
        "
        class="d-flex align-items-center m-2 mt-3 drip-body-small"
      >
        <div
          class="showAllButton color-wealthy-green-500 cursor-pointer"
          @click="showAllBanks"
        >
          {{ $t('coverLetter.seeAll') }}
          <b-icon-chevron-down
            font-scale="1.2"
            class="color-wealthy-green-500 ml-1"
          />
        </div>
      </div>
    </b-card>
    <b-modal v-model="showModal" hide-header centered hide-footer size="md">
      <div class="d-flex flex-column align-items-center mt-3 mb-4">
        <div class="cursor-pointer ml-auto mr-3 mb-2" @click="cancelDialog">
          <b-icon-x scale="1.6" class="color-wealthy-green-500" />
        </div>
        <div class="drip-h3 mb-2 text-center color-noble-blue-500">
          {{ $t('coverLetter.modal.prependTitle') }} {{ getBuyerBankName }} -
          {{ getBuyerBankSwift }} {{ $t('coverLetter.modal.appendTitle') }}
        </div>
        <div class="drip-body mb-4 font-weight-400">
          {{ $t('coverLetter.modal.subtitle') }}
        </div>
        <div class="d-flex">
          <action-button variant="solid" :click="deleteDialog" class="mr-2">
            {{ $t('coverLetter.modal.deleteButton') }}
          </action-button>
          <action-button variant="outline" :click="cancelDialog">
            {{ $t('coverLetter.modal.cancelButton') }}
          </action-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton'
import bankService from '@/services/bank'

export default {
  props: {
    bankList: {
      type: Array,
      required: false,
      default: () => []
    },
    selectedBank: {
      type: [String, Number],
      required: false,
      default: ''
    },
    buyer: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      collapseStates: [],
      editStates: [],
      selectStates: [],
      showModal: false,
      deletedIndex: -1,
      listLimit: 3
    }
  },
  components: {
    ActionButton
  },
  computed: {
    getBuyerBankName() {
      return this.selectedBank >= 0 && this.bankList[this.selectedBank]
        ? this.bankList[this.selectedBank].buyer_bank_name
        : ''
    },
    getBuyerBankSwift() {
      return this.selectedBank >= 0 && this.bankList[this.selectedBank]
        ? this.bankList[this.selectedBank].swift_code
        : ''
    }
  },
  // TODO - TECH_DEBT - requires component to be re-review
  methods: {
    showAllBanks() {
      this.listLimit = this.bankList.length
    },
    openDialog(index) {
      this.deletedIndex = index
      this.showModal = true
    },
    deleteDialog() {
      bankService
        .removeBank(
          this.buyer.id,
          this.bankList[this.deletedIndex] &&
            this.bankList[this.deletedIndex].id
        )
        .then(() => {
          this.$emit('fetch-bank-list')
          this.$notify({
            title: 'Bank Deleted Successfully',
            type: 'success'
          })
          this.showModal = false
        })
        .catch((e) => {
          this.showModal = false
        })
    },
    cancelDialog() {
      this.showModal = false
    },
    openAccordion(i) {
      if (!this.collapseStates[i]) {
        this.$refs[`accordion-${i}`][0].click()
      }
    },
    closeAccordion(i) {
      if (this.collapseStates[i]) {
        this.$refs[`accordion-${i}`][0].click()
      }
    },
    accordionIsOpen(i) {
      return this.collapseStates[i]
    },
    onEditClick(i) {
      if (this.accordionIsOpen(i)) {
        this.closeAccordion(i)
        return setTimeout(() => {
          this.editStates[i] = true
          this.openAccordion(i)
        }, 0)
      }
      this.editStates[i] = true
      this.openAccordion(i)
    },
    resetEditStates() {
      this.collapseStates.forEach((v, i) => {
        if (!v) {
          this.editStates[i] = v
        }
      })
    },
    setCollapseAndEditStates(count) {
      for (let i = 0; i < count; i++) {
        this.collapseStates[i] = false
        this.editStates[i] = false
        this.selectStates[i] = false
      }
    },
    setSelectStates(index) {
      if (index >= 0) {
        this.openAccordion(index)
        this.$emit('selected-bank-index', index)
      } else {
        this.selectStates[index] = false
      }
    }
  },
  watch: {
    bankList: {
      handler(newVal) {
        this.setCollapseAndEditStates(newVal.length)
      },
      deep: true,
      immediate: true
    },
    collapseStates: {
      handler() {
        this.resetEditStates()
      },
      deep: true
    },
    selectStates: {
      handler(newVal) {
        if (!newVal.find((s) => s)) {
          this.$emit('selected-bank-index', '-1')
        }
      },
      deep: true
    }
  },
  mounted() {
    this.selectStates[this.selectedBank] = true
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.w-200 {
  width: 200px;
}
.banks-accordion {
  background: white;
  border: 1px solid $sky-blue-400;
  border-radius: 8px;
  padding: 4px 12px;
  margin-bottom: 8px;
  max-height: 450px;
  overflow: scroll;

  .collapse-header {
    flex: 1;
    width: 80%;

    .bank-name {
      font-weight: 700;
      font-size: 1.25rem;
      color: $dc-blue;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 84%;
    }
  }

  .trash {
    cursor: pointer;
    margin-right: 4px;
    padding: 6px;
    outline: none;
    color: $wealthy-green-600;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    &:hover {
      background: $wealthy-green-50;
    }
  }
  .chevron {
    cursor: pointer;
    color: $wealthy-green-600;
    outline: none;
    padding: 6px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    &:hover {
      background: $wealthy-green-50;
    }
    &.active {
      background: $wealthy-green-50;
    }
  }

  .bank-accordion-card {
    .divider {
      width: 98%;
      background: $sky-blue-400;
      height: 1px;
      margin: auto;
    }
    .accordion-body {
      margin-left: 24px;
    }
  }

  .action-icon {
    cursor: pointer;
  }

  .checkbox-container {
    width: 24px;
    height: fit-content;
  }
}
.showAllButton {
  padding: 4px 12px;
  &:hover {
    width: fit-content;
    background: $wealthy-green-50;
    border-radius: 50px;
  }
}
</style>
